import React from 'react';
import { usePlannerStore } from '../state/usePlannerStore';

const GlobalLoader: React.FC = () => {
  const isLoadingGlobal = usePlannerStore((state) => state.isLoadingGlobal);

  if (!isLoadingGlobal) return null;

  return (
    <>
      <style>
        {`
          .loader {
            width: 40px;
            aspect-ratio: 1.154;
            --_g: no-repeat radial-gradient(farthest-side, #d8328f 90%, #0000);
            background:
              var(--_g) 50% 0,
              var(--_g) 0 100%,
              var(--_g) 100% 100%;
            background-size: 35% calc(35% * 1.154);
            animation: l16 1s infinite;
          }

          @keyframes l16 {
            50%,
            100% {
              background-position:
                100% 100%,
                50% 0,
                0 100%;
            }
          }
        `}
      </style>

      <div
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(252, 250, 250, 0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(4px)',
        }}
      >
        <div className="loader" />
      </div>
    </>
  );
};

export default GlobalLoader;